import { IconButton } from '@mui/material';
import { ReactComponent as UserIcon } from 'assets/icons/User.svg';
import { useCurrentUserQuery } from 'generated/graphql';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '../Avatar/Avatar';
import { styles } from './UserHeaderMenuAvatar.styles';
import { UserHeaderMenuPopper } from './UserHeaderMenuPopper';

export const UserHeaderMenuAvatar: React.FC = () => {
  const { t } = useTranslation();
  const { data: currentUserData } = useCurrentUserQuery();

  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const isOpen = !!anchorElement;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => setAnchorElement(event.currentTarget);

  const handleClose = () => setAnchorElement(null);

  return (
    <>
      <IconButton aria-label={t('userHeaderMenu.avatarButtonAriaLabel')} onClick={handleClick} sx={styles.button}>
        <Avatar avatar={currentUserData?.user?.avatar} size="thumbnail" sx={styles.avatar}>
          <UserIcon />
        </Avatar>
      </IconButton>
      <UserHeaderMenuPopper anchorElement={anchorElement} onClose={handleClose} open={isOpen} />
    </>
  );
};
